"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Brc20RouterABI = void 0;
var Brc20RouterLogic_1 = require("./Brc20RouterLogic");
Object.defineProperty(exports, "Brc20RouterABI", { enumerable: true, get: function () { return __importDefault(Brc20RouterLogic_1).default; } });
//# sourceMappingURL=index.js.map